import React from 'react';

interface IProps {
  children: React.ReactNode;
}

const ReviewItemWrapper = ({ children }: IProps) => (
  <div className='flex flex-col border border-bw03 rounded-[8px]'>{children}</div>
);

export default ReviewItemWrapper;
